/**
 * Configuración de entornos para la aplicación
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';
const isTest = process.env.NODE_ENV === 'test';

// Configuración de React
export const reactConfig = {
  strictMode: isDevelopment,
  errorBoundary: isProduction,
  devTools: isDevelopment,
  enableProfiler: isDevelopment,
  enableConcurrentFeatures: true
};

// Configuración de errores
export const errorConfig = {
  enableErrorBoundaries: true,
  enableErrorLogging: isProduction,
  enableErrorReporting: isProduction,
  showErrorDetails: isDevelopment,
  maxErrorRetries: 3
};

// Configuración de performance
export const performanceConfig = {
  enableProfiling: isDevelopment,
  enableLazyLoading: true,
  enableCodeSplitting: true,
  enableServiceWorker: isProduction
};

// Configuración de desarrollo
export const developmentConfig = {
  enableHotReload: isDevelopment,
  enableSourceMaps: isDevelopment,
  enableReactDevTools: isDevelopment,
  enableConsoleLogs: isDevelopment
};

// Configuración general
export const appConfig = {
  name: 'Free SERP Checker',
  version: '2.8.0',
  environment: process.env.NODE_ENV,
  isDevelopment,
  isProduction,
  isTest,
  
  // URLs
  baseUrl: isProduction ? 'https://freeserpchecker.org' : 'http://localhost:3000',
  
  // API endpoints
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'https://freeserpchecker.org',
    timeout: 30000
  },
  
  // Features
  features: {
    enableAnalytics: isProduction,
    enableErrorTracking: isProduction,
    enablePerformanceMonitoring: isProduction
  }
};

// Función para obtener configuración específica
export const getConfig = (configType) => {
  const configs = {
    react: reactConfig,
    error: errorConfig,
    performance: performanceConfig,
    development: developmentConfig,
    app: appConfig
  };
  
  return configs[configType] || appConfig;
};

// Función para verificar si una característica está habilitada
export const isFeatureEnabled = (featureName) => {
  return appConfig.features[featureName] || false;
};

export default appConfig;
